import { Popover2 } from '@blueprintjs/popover2'
import React, { useState } from 'react'
import PulsatingDot from '../../../onboarding/Pulsating/PulsatingDot'
import firebase from 'firebase/app';



function CustomTopic({
    setIntVal,
    onboarded,
    auth,
    intVal
}) {

    const [ inputValue, setInputValue ] = useState('')

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }

    const clickedDone = () =>{
        firebase
        .firestore()
        .collection('onboards')
        .doc(auth.uid)
        .update({
            // onboarded: "yes",
            customInt: "yes"
        })
    }

    const setCustomTopic = (e) =>{
        setIntVal(e)
        setInputValue(e)
    }

    return (
        <div className="">
            <div className='p-2 -mt-4 flex'>
                {/* <h2 className="text-lg font-semibold mt-0 ml-2">Custom Topic</h2> */}
                {onboarded?.[0]?.customInt === 'no' ?
                <Popover2
                    content={
                        <div className="p-4 w-72">
                            <div className="text-lg font-semibold">
                                Write About A Custom Topic
                            </div>
                            <div className="my-2">
                                Sometimes there are topics you want to write about that Bound did not find. <br /><br /> Enter in custom topics here like "Likes to play golf" or "Wrote an Article about Sales Success" and Bound will incorporate it into your messages.
                            </div>
                            <div className="mt-2 ml-auto">
                                <button 
                                    className="bg-red-600 hover:bg-red-500 text-white rounded-lg py-0.5 px-2 font-semibold"
                                    onClick={clickedDone}    
                                >
                                    Got It
                                </button>
                            </div>
                        </div>
                    }
                    interactionKind="hover"
                    placement="right"
                    >
                        <div className="mt-1">
                        <PulsatingDot />
                        </div>
                    </Popover2>
                    :
                    null
                    }
            </div>
            <div className='p-2 pl-3 pt-0 pb-6'>
                <input 
                placeholder="Custom Topic To Write About (Ex: Hockey)"
                type="text"
                name="topic"
                id="topic"
                autoComplete="off"
                value={inputValue}
                className={classNames(
                    intVal === inputValue ? "ring-blue-700 ring-4" : "", "shadow-sm p-2 focus:outline-none block w-full sm:text-sm border-blue-300 border-2 rounded-md"
                )}
                onChange={(e) => setCustomTopic(e.target.value)}
                onClick={(e) => setCustomTopic(e.target.value)}
                />
            </div> 
        </div>
    )
}

export default CustomTopic
